import React, {useState} from "react";
import PropTypes from "prop-types";
import {injectIntl} from "react-intl";

import ArrowLeftIcon from '@mui/icons-material/ArrowLeft';
import ArrowRightIcon from '@mui/icons-material/ArrowRight';
import IconButton from "@mui/material/IconButton";

import GroheCartDesignRecommendedFeature from "./groheCartDesignRecommendedFeature";
import {featureInterface} from "../../../../../interfaces/featureInterface";

const ITEMS_IN_ROW = 3;
const ITEM_WIDTH = 240;

const GroheCartDesignRecommendedList = (props) => {

  const {featuresList, zoomToFeatureGroup, intl} = props;
  const [translateIndex, setTranslateIndex] = useState(0);

  const slideButtonCLick = (next) => {
    setTranslateIndex(translateIndex + next)
  }

  // console.log("translateIndex", -translateIndex);
  // console.log("featuresList.length - ITEMS_IN_ROW", featuresList.length - ITEMS_IN_ROW);
  const leftDisabled = featuresList.length < ITEMS_IN_ROW || (-translateIndex === (featuresList.length - ITEMS_IN_ROW));
  const rightDisabled = featuresList.length < ITEMS_IN_ROW || !translateIndex;

  return (
    <div className="gc-recommended__slider">
      <IconButton aria-label={intl.formatMessage({id:"iconButton.back"})}
                  disabled={rightDisabled}
                  className="look-icon look-icon--small gc-recommended__slider-button gc-recommended__slider-button--left"
                  onClick={() => slideButtonCLick(1)}>
        <ArrowLeftIcon/>
      </IconButton>
      <ul className="gc-recommended__list">
        {featuresList.map((navItem) => {
          const transform = translateIndex ? `translateX(${ITEM_WIDTH * translateIndex}px)` : "none";
          return <GroheCartDesignRecommendedFeature key={navItem.part.dbFeature.id}
                                                    styles={{transform}}
                                                    zoomToFeatureGroup={zoomToFeatureGroup}
                                                    feature={navItem.part}/>
        })}
      </ul>
      <IconButton aria-label={intl.formatMessage({id:"iconButton.next"})}
                  disabled={leftDisabled}
                  className="look-icon look-icon--small gc-recommended__slider-button gc-recommended__slider-button--right"
                  onClick={() => slideButtonCLick(-1)}>
        <ArrowRightIcon/>
      </IconButton>
    </div>
  )
};

GroheCartDesignRecommendedList.propTypes = {
  featuresList: PropTypes.arrayOf(PropTypes.shape(featureInterface)),
  zoomToFeatureGroup: PropTypes.func.isRequired,
}

export default injectIntl(GroheCartDesignRecommendedList)
